import apiClient from "./apiClient";

export const fetchStandards = async () => {
  const response = await apiClient.get("/standards");
  return response.data;
};

export const fetchStandardsSubcategory = async (
  standardName,
  pipeTypeSewer
) => {
  const response = await apiClient.get("/standards/subcategories", {
    params: {
      standard_key__name: standardName,
      pipe_type_sewer: pipeTypeSewer,
    },
  });
  return response.data;
};

export const fetchCodeVariants = async (subcategoryId) => {
  const response = await apiClient.get(
    `/standards/subcategories/${subcategoryId}/code-variants`
  );
  return response.data;
};
